/**
 *  Component: (common) Plugin Features
 */
import React, { useState, useEffect } from 'react';

import { Flex } from '@chakra-ui/react';
import { Grid } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import { PLUGIN_FEATURES_MAPPING } from 'constants/ProjectConstants';
import { EditNotificationIcon, InfoIcon2 } from 'constants/icons';
import { routes } from 'constants/routes';
import theme from 'constants/theme';

import {
  deleteTeamChannelMapping,
  getChannels,
  getPluginFeatures,
  getSlackApplauseDetails,
  getTeamChannelMappings,
  saveSlackApplauseMapping,
  updateSlackApplauseChannelMapping,
} from 'services/plugins';
import { showErrorSnackbar } from 'services/snackbar';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { ApplauseContainer } from './Slack/linkTeamWithChannel';
import { BodyContainer, Icon, FormContainer, FormHeading } from './styles';

const PluginFeatures = ({ thirdPartyType = '', setShowApplauseModule, heading }) => {
  const dispatch = useDispatch();
  const [dataLoading, setDataLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [features, setFeatures] = useState([]);

  const [applauseFieldStatus, setapplauseFieldStatus] = useState([]);

  const getFeatures = () => {
    setDataLoading(true);
    getPluginFeatures({ thirdPartyType })
      .then((res) => {
        // conditional loop code to set showApplause module using setShowApplauseModule
        if (res.length) {
          // setFeatures(res);
          res.forEach((res) => {
            if (res.featureType === 'APPLAUSE' && setShowApplauseModule) {
              setShowApplauseModule(res.enabled);
            }
          });
        } else {
          // dispatch(showInfoSnackbar('No features were found'), 4000);
        }
      })
      .catch((err) => dispatch(showErrorSnackbar('Sorry, unable to fetch the features!')))
      .finally(() => setDataLoading(false));
  };

  // useEffect(getFeatures, []);

  // const updateFeature = (event, selectedFeature) => {
  //   const checked = event.target.checked;
  //   let updatedFeatures = features.map(f => {
  //     if (f.id === selectedFeature.id) {
  //       f.enabled = checked;
  //     }
  //     return f;
  //   });
  //   setFeatures(updatedFeatures);
  //   setLoading(true);
  //   updatePluginFeature({
  //     ...selectedFeature,
  //     thirdPartyType,
  //     enabled: event.target.checked
  //   })
  //     .then(res => {
  //       getFeatures();
  //     })
  //     .catch(err => {
  //       updatedFeatures = features.map(f => {
  //         if (f.id === selectedFeature.id) {
  //           f.enabled = !checked;
  //         }
  //         return f;
  //       });
  //       setFeatures(updatedFeatures);
  //       dispatch(showErrorSnackbar('Sorry, unable to update the feature!'));
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // };

  const [mappings, setMappings] = useState([]);
  const [channels, setChannels] = useState([]);

  const getAllChannels = () => {
    setDataLoading(true);
    getChannels({ thirdPartyType })
      .then((res) => {
        if (res.length) {
          setChannels(res.map((channel) => ({ value: channel.id, label: channel.name })));
          getMappings();
        } else {
          dispatch(showErrorSnackbar('No channels were found'));
          setDataLoading(false);
        }
      })
      .catch((err) => {
        dispatch(showErrorSnackbar('Sorry, unable to fetch the channels!'));
        setDataLoading(false);
      });
  };

  const getFeatureLabel = (featureType) =>
    PLUGIN_FEATURES_MAPPING[featureType]
      ? PLUGIN_FEATURES_MAPPING[featureType]
      : `${featureType.underscoreLess().toProperCase()}s`;

  const getMappings = () => {
    setDataLoading(true);
    getTeamChannelMappings({ thirdPartyType })
      .then((mappings) => {
        setMappings(mappings);
      })
      .catch((err) => dispatch(showErrorSnackbar('Sorry, unable to fetch the mappings')))
      .finally(() => setDataLoading(false));
  };

  const getSlackApplause = () => {
    setDataLoading(true);
    getSlackApplauseDetails()
      .then((res) => {
        setapplauseFieldStatus(
          res.map((channel) => ({
            value: channel.thirdPartyTeamId,
            label: channel.thirdPartyTeamName,
            uuid: channel.uuid,
          }))
        );
      })
      .catch((err) => dispatch(showErrorSnackbar('Sorry, unable to fetch the mappings!')))
      .finally(() => setDataLoading(false));
  };

  useEffect(() => {
    setDataLoading(true);
    getSlackApplause();
    getAllChannels();
  }, []);

  const updateApplauseMapping = (value, label, mappingId) => {
    updateSlackApplauseChannelMapping({
      thirdPartyTeamId: value,
      thirdPartyTeamName: label,
      mappingId,
    })
      .then((res) => {
        getSlackApplause();
      })
      .catch((err) => dispatch(showErrorSnackbar('Sorry, unable to save the mapping!')));
  };

  const deleteMapping = (mappingId) => {
    setLoading(true);
    deleteTeamChannelMapping({ thirdPartyType, mappingId })
      .then((res) => {
        getMappings();
      })
      .then(() => getSlackApplause())
      .catch((err) => {
        dispatch(showErrorSnackbar('Sorry, unable to delete the mapping!'));
      })
      .finally(() => setLoading(false));
  };

  const saveApplauseMapping = (value, label) => {
    saveSlackApplauseMapping({ thirdPartyTeamId: value, thirdPartyTeamName: label })
      .then((res) => {
        getSlackApplause();
      })
      .catch((err) => dispatch(showErrorSnackbar('Sorry, unable to save the mapping!')));
  };

  // if (features.length === 0) {
  //   return null;
  // }

  return (
    <FormContainer>
      <FormHeading>
        <Icon>
          <EditNotificationIcon color="#333" size="fixed22px" />
        </Icon>
        {heading}
      </FormHeading>
      {/* <Separator /> */}

      <BodyContainer style={{ paddingBottom: '0.5rem' }}>
        {dataLoading ? (
          <Grid container>
            <Grid item xs={5}>
              <Skeleton height="30px" />
              <Skeleton height="30px" />
            </Grid>
            <Grid item xs={2} />
            <Grid item xs={5}>
              <Skeleton height="30px" width="80%" />
              <Skeleton height="30px" width="80%" />
            </Grid>
          </Grid>
        ) : (
          <>
            {/* <Grid container>
              {features.map((feature, idx) => (
                <React.Fragment>
                  {idx % 2 === 0 ? (
                    <React.Fragment>
                      <StyledGrid item xs={5}>
                        Enable {getFeatureLabel(feature.featureType)} on slack
                        <AntSwitch
                          disabled={loading}
                          checked={feature.enabled}
                          onChange={e => updateFeature(e, feature)}
                        />
                      </StyledGrid>
                      <Grid item xs={2} style={{ position: 'relative' }}></Grid>
                    </React.Fragment>
                  ) : (
                    <StyledGrid item xs={4}>
                      Enable {getFeatureLabel(feature.featureType)} on slack
                      <AntSwitch
                        disabled={loading}
                        checked={feature.enabled}
                        onChange={e => updateFeature(e, feature)}
                      />
                    </StyledGrid>
                  )}
                </React.Fragment>
              ))}
            </Grid> */}
            <div style={{ marginTop: '20px' }}>
              {applauseFieldStatus.length ? (
                <ApplauseContainer
                  channels={channels}
                  loading={loading}
                  updateFn={updateApplauseMapping}
                  deleteFn={deleteMapping}
                  value={applauseFieldStatus}
                />
              ) : (
                <ApplauseContainer channels={channels} loading={loading} saveFn={saveApplauseMapping} />
              )}
            </div>
            <Flex>
              <InfoIcon2 color={theme.palette.icons.grey4} size="fixed16px" />
              <Flex>
                <TextBodyMedium ml="6px" color="text.g2">
                  Configure personalized Slack notifications from
                </TextBodyMedium>
                <Link style={{ textDecoration: 'none' }} to={routes.settings.notifications}>
                  <TextBodyMedium
                    cursor="pointer"
                    color="primary.1565BC"
                    style={{ textDecoration: 'underline' }}
                    ml="2px"
                  >
                    Notifications Settings
                  </TextBodyMedium>
                </Link>
              </Flex>
            </Flex>
          </>
        )}
      </BodyContainer>
    </FormContainer>
  );
};

export default PluginFeatures;
